<template>
  <router-link
    :to="{ path: path }"
    event
    class="is-grey mb-2 previous_link"
    @click.native.prevent="beforeClick({ path: path })"
  >
    <i class="mdi mdi-chevron-left" />

    {{ title }}
  </router-link>
</template>

<script>

import router from "@/admin/router";

export default {
  props:{
    path: {
      required:true,
      type: String
    },
    title : {
      default: "",
      type : String
    },
    beforeClick: {
      type: Function,
      default: (route) => {
        router.push(route);
      },
    },
  }
};
</script>
